import React, { useState } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const TabComponent = () => {
  var settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
        {
          breakpoint: 767,
          settings: {
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
  };
    const [activeTab, setActiveTab] = useState('overview');
  
    const renderTabContent = () => {
      switch (activeTab) {
        case 'overview':
          return (
            <div className="tab-pane fade show active" id="overview">
              <div className="tab-inner">
                <div className="row">
                  <div className="col-md-5">
                    <div className="hotel-type mb-xl-20 bg-light-white padding-10">
                      <ul className="custom">
                        <li className="text-light-dark">
                          <label className="no-margin text-custom-blue">Rental Company:</label> EZ Rent a Car
                        </li>
                        <li className="text-light-dark">
                          <label className="no-margin text-custom-blue">Car Type</label> Economy
                        </li>
                        <li className="text-light-dark">
                          <label className="no-margin text-custom-blue">Car Name</label> Toyota Auris
                        </li>
                        <li className="text-light-dark">
                          <label className="no-margin text-custom-blue">Passenger</label> 4
                        </li>
                        <li className="text-light-dark">
                          <label className="no-margin text-custom-blue">Baggage</label> 2
                        </li>
                        <li className="text-light-dark">
                          <label className="no-margin text-custom-blue">Car Features</label> Available
                        </li>
                        <li className="text-light-dark">
                          <label className="no-margin text-custom-blue">Taxs & Fees</label> $155.60
                        </li>
                        <li className="text-light-dark">
                          <label className="no-margin text-custom-blue">Total Price</label> $201
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="col-md-7">
                    <div className="listing-testimonial padding-20 bg-light-white mb-xl-20">
                      <Slider {...settings} className="testimonial-inner detail-testimonial">
                        <div className="tesimonial-item">
                          <cite className="text-custom-blue fs-16">
                            Always enjoyed my stay with Hilton Hotel and Resorts, top class room service and rooms have great outside views and luxury accessories.
                          </cite>
                          <div className="testimonial-author">
                            <div className="author-img">
                              <img src="/tm/react/bycycle/assets/images/blog/comment_1.jpg" className="rounded-circle" alt="img" />
                            </div>
                            <div className="author-name ml-2">
                              <h6 className="text-custom-black no-margin fs-14 fw-500">Jhon</h6>
                              <p className="no-margin text-light-dark">Passenger</p>
                            </div>
                          </div>
                        </div>
                        <div className="tesimonial-item">
                          <cite className="text-custom-blue fs-16">
                            Always enjoyed my stay with Hilton Hotel and Resorts, top class room service and rooms have great outside views and luxury accessories.
                          </cite>
                          <div className="testimonial-author">
                            <div className="author-img">
                              <img src="/tm/react/bycycle/assets/images/blog/comment_2.jpg" className="rounded-circle" alt="img" />
                            </div>
                            <div className="author-name ml-2">
                              <h6 className="text-custom-black no-margin fs-14 fw-500">Jhon</h6>
                              <p className="no-margin text-light-dark">Passenger</p>
                            </div>
                          </div>
                        </div>
                      </Slider>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="information">
                      <h4 className="text-custom-black">Car Rental Information</h4>
                      <p className="text-light-dark">
                        Sed aliquam nunc eget velit imperdiet, in rutrum mauris malesuada. Quisque ullamcorper vulputate nisi, et fringilla ante convallis quis. Nullam vel tellus non elit suscipit volutpat. Integer id felis et nibh rutrum dignissim ut non risus. In tincidunt urna quis sem luctus, sed accumsan magna pellentesque. Donec et iaculis tellus. Vestibulum ut iaculis justo, auctor sodales lectus. Donec et tellus tempus, dignissim maurornare, consequat lacus. Integer dui neque, scelerisque nec sollicitudin sit amet, sodales a erat. Duis vitae condimentum ligula. Integer eu mi nisl. Donec massa dui, commodo id arcu quis, venenatis scelerisque velit.
                      </p>
                      <p className="text-light-dark no-margin">
                        Sed aliquam nunc eget velit imperdiet, in rutrum mauris malesuada. Quisque ullamcorper vulputate nisi, et fringilla ante convallis quis. Nullam vel tellus non elit suscipit volutpat. Integer id felis et nibh rutrum dignissim ut non risus. In tincidunt urna quis sem luctus, sed accumsan magna pellentesque. Donec et iaculis tellus. Vestibulum ut iaculis justo, auctor sodales lectus. Donec et tellus tempus, dignissim maurornare, consequat lacus. Integer dui neque, scelerisque nec sollicitudin sit amet, sodales a erat. Duis vitae condimentum ligula. Integer eu mi nisl. Donec massa dui, commodo id arcu quis, venenatis scelerisque velit.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        case 'amenities':
          return (
            <div className="tab-pane fade show active" id="amenities">
              <h4 className="text-custom-black">Amenities</h4>
              <p className="text-light-dark">
                Maecenas vitae turpis condimentum metus tincidunt semper bibendum ut orci. Donec eget accumsan est. Duis laoreet sagittis elit et vehicula. Cras viverra posuere condimentum.
              </p>
              <ul className="custom amenities row no-gutters mb-xl-20">
                <li className="col-sm-6">
                  <div className="icon-box text-light-dark">
                    <i className="fab fa-youtube"></i> 4 Passengers
                  </div>
                </li>
                <li className="col-sm-6">
                  <div className="icon-box text-light-dark">
                    <i className="fab fa-youtube"></i> 2 Bags
                  </div>
                </li>
                <li className="col-sm-6">
                  <div className="icon-box text-light-dark">
                    <i className="fab fa-youtube"></i> Air Conditioning
                  </div>
                </li>
                <li className="col-sm-6">
                  <div className="icon-box text-light-dark">
                    <i className="fab fa-youtube"></i> Satellite Navigation
                  </div>
                </li>
                <li className="col-sm-6">
                  <div className="icon-box text-light-dark">
                    <i className="fab fa-youtube"></i> Diesel Vehicle
                  </div>
                </li>
                <li className="col-sm-6">
                  <div className="icon-box text-light-dark">
                    <i className="fab fa-youtube"></i> Automatic Transmission
                  </div>
                </li>
              </ul>
              <h4 className="text-custom-black">Travel Info</h4>
              <p className="text-light-dark">
                Maecenas vitae turpis condimentum metus tincidunt semper bibendum ut orci. Donec eget accumsan est. Duis laoreet sagittis elit et vehicula. Cras viverra posuere condimentum.
              </p>
              <div className="travel-info bg-light-white">
                <div className="row no-gutters">
                  <div className="col-sm-6">
                    <div className="head padding-20">
                      <h5 className="text-custom-black fs-14 fw-500 no-margin">Pick-up location details</h5>
                      <span className="text-light-dark fs-12">Phone: (+247) 123 456 7890</span>
                    </div>
                    <div className="travel-info-body padding-20">
                      <div className="date-wrapper mb-xl-20">
                        <div className="icon text-custom-blue fs-20">
                          <i className="far fa-clock"></i>
                        </div>
                        <div className="text">
                          <p className="text-custom-black no-margin">Pickup Time</p>
                          <span className="text-light-dark fs-12">THU, March 14, 2024 | 11:00 AM</span>
                        </div>
                      </div>
                      <div className="date-wrapper">
                        <div className="icon text-custom-blue fs-20">
                          <i className="fas fa-map-marker-alt"></i>
                        </div>
                        <div className="text">
                          <p className="text-custom-black no-margin">Location</p>
                          <span className="text-light-dark fs-12">London City, Airport</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="head padding-20">
                      <h5 className="text-custom-black fs-14 fw-500 no-margin">Drop-off location details</h5>
                      <span className="text-light-dark fs-12">Phone: (+247) 123 456 7890</span>
                    </div>
                    <div className="travel-info-body padding-20">
                      <div className="date-wrapper mb-xl-20">
                        <div className="icon text-custom-blue fs-20">
                          <i className="far fa-clock"></i>
                        </div>
                        <div className="text">
                          <p className="text-custom-black no-margin">Drop Off Time</p>
                          <span className="text-light-dark fs-12">FRI, Fab 15, 2024 | 11:00 AM</span>
                        </div>
                      </div>
                      <div className="date-wrapper">
                        <div className="icon text-custom-blue fs-20">
                          <i className="fas fa-map-marker-alt"></i>
                        </div>
                        <div className="text">
                          <p className="text-custom-black no-margin">Location</p>
                          <span className="text-light-dark fs-12">Paris Orly, Airport</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        default:
          return null;
      }
    };
  
    return (
      <div className='tabs'>

        <ul className="custom-flex nav nav-tabs mb-xl-20">
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === 'overview' ? 'active' : ''}`}
              onClick={() => setActiveTab('overview')}
            >
              Overview
            </button>
          </li>
          <li className="nav-item">
            <button
              className={`nav-link ${activeTab === 'amenities' ? 'active' : ''}`}
              onClick={() => setActiveTab('amenities')}
            >
              Amenities
            </button>
          </li>
        </ul>
        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>
    );
  };
  
  export default TabComponent;